import * as yup from "yup";

export const changeRoleSchema = yup.object().shape({
    admin: yup.number().required()
}).required();